import { render, staticRenderFns } from "./addActivity.vue?vue&type=template&id=4fa110fd&scoped=true"
import script from "./addActivity.vue?vue&type=script&lang=js"
export * from "./addActivity.vue?vue&type=script&lang=js"
import style0 from "./addActivity.vue?vue&type=style&index=0&id=4fa110fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa110fd",
  null
  
)

export default component.exports